/**
 * Отказ скрытия монеты §75 назван, а не молчит — тот же приём, что
 * `favorite-notice.ts`: уведомление несёт монету, общая полоса над списком
 * называет её, а панель показывает отказ только о своей монете.
 *
 * Два вида отказа: `400` — демон отверг саму запись, повтор отклонится так же;
 * временная недоступность — тот случай, где «попробуйте ещё раз» осмысленно.
 * Возврат монеты уведомления здесь не имеет: он живёт в листе «Скрытые монеты»
 * и называет отказ внутри листа.
 */
export type HideCoinNotice = { kind: "invalid" | "retry"; base: string } | null;

export function hideCoinNotice(
  status: "ok" | "invalid" | "unavailable",
  base: string,
): HideCoinNotice {
  if (status === "ok") {
    return null;
  }
  return { kind: status === "invalid" ? "invalid" : "retry", base };
}

/** Текст уведомления — общий для полосы над списком и панели. */
export function hideCoinNoticeText(notice: NonNullable<HideCoinNotice>): string {
  return notice.kind === "invalid"
    ? `Демон отверг скрытие монеты ${notice.base}.`
    : `Монета ${notice.base} не скрыта — попробуйте ещё раз.`;
}

/**
 * Уведомление после старта или успеха скрытия монеты `base`: гасит только своё,
 * отказ по другой монете остаётся, пока его не закроют явно.
 */
export function clearHideNoticeForBase(previous: HideCoinNotice, base: string): HideCoinNotice {
  return previous !== null && previous.base !== base ? previous : null;
}
